import { useState } from 'react';
import { Stars, Prix, Badge } from '../ui/UI';

const CUISINE_EMOJIS = {
  'Italien': '🍕', 'Japonais': '🍣', 'Français': '🥐', 'Mexicain': '🌮',
  'Indien': '🍛', 'Chinois': '🥟', 'Américain': '🍔', 'Grec': '🫒',
  'Thaïlandais': '🍜', 'Libanais': '🧆', 'Espagnol': '🥘', 'Autre': '🍽️',
};

function StatutBadge({ statut }) {
  if (!statut) return null;
  if (statut === 'tester') return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 50, fontSize: 11, fontWeight: 700, background: '#FEF3C7', color: '#D97706' }}>
      📌 À tester
    </span>
  );
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 50, fontSize: 11, fontWeight: 700, background: '#D1FAE5', color: '#059669' }}>
      ✅ Testé
    </span>
  );
}

export default function RestaurantCard({ restaurant, monStatut, onClick }) {
  const [imgError, setImgError] = useState(false);
  const { nom, adresse, type_cuisine, note_moyenne, nb_avis, niveau_prix, photos, added_by_profile } = restaurant;
  const emoji = CUISINE_EMOJIS[type_cuisine] || '🍽️';
  const photo = !imgError && photos?.[0]?.url;
  const createur = added_by_profile?.username;

  return (
    <article onClick={onClick} style={{
      background: 'var(--surface)', borderRadius: 'var(--radius-lg)',
      overflow: 'hidden', cursor: 'pointer',
      boxShadow: 'var(--shadow-sm)', border: '1px solid var(--border)',
      transition: 'transform 0.2s, box-shadow 0.2s',
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = 'var(--shadow-lg)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; }}
    >
      {/* Image */}
      <div style={{ height: 180, background: 'linear-gradient(135deg, #FFF0F1, #FFF5F0)', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {photo ? (
          <img src={photo} alt={nom} onError={() => setImgError(true)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span style={{ fontSize: 64, opacity: 0.6 }}>{emoji}</span>
        )}
        {/* Statut personnel en haut à droite */}
        <div style={{ position: 'absolute', top: 10, right: 10 }}>
          <StatutBadge statut={monStatut} />
        </div>
        {type_cuisine && (
          <div style={{ position: 'absolute', bottom: 10, left: 10 }}>
            <Badge color="gray">{emoji} {type_cuisine}</Badge>
          </div>
        )}
      </div>

      {/* Content */}
      <div style={{ padding: '14px 16px 16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, lineHeight: 1.3, flex: 1, paddingRight: 8 }}>{nom}</h3>
          <Prix niveau={niveau_prix} />
        </div>

        <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 4 }}>
          <span>📍</span>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{adresse}</span>
        </p>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {note_moyenne ? (
              <>
                <Stars note={Math.round(note_moyenne)} size={13} />
                <span style={{ fontSize: 13, fontWeight: 700 }}>{note_moyenne}</span>
                <span style={{ fontSize: 12, color: 'var(--text-3)' }}>({nb_avis})</span>
              </>
            ) : (
              <span style={{ fontSize: 12, color: 'var(--text-3)' }}>Pas encore d'avis</span>
            )}
          </div>

          {createur && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <div style={{ width: 20, height: 20, borderRadius: '50%', background: 'linear-gradient(135deg, var(--brand), var(--brand-light))', color: '#fff', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {createur[0].toUpperCase()}
              </div>
              <span style={{ fontSize: 11, color: 'var(--text-3)', fontWeight: 500 }}>{createur}</span>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
